import { post } from '@/utils/request'

export const queryCurrencyOptions = () => post('/currency/queryCurrencyOptions', {})

export const queryCurrencyExchangeRateAndSymbol = () => post('/currency/queryCurrencyExchangeRateAndSymbol', {})